<template>
  <div class="grid place-items-center items-center md:h-screen mt-5 md:mt-0">
    <section class="col-span-12 md:col-span-5 md:w-5/12">
      <div
        class="bg-white shadow-md rounded-xl overflow-hidden lg:m-10"
      >
        <div class="bg-gray-50 p-5">
          <span class="text-2xl font-medium mb-3">
            {{
              $t("labels.generic", {
                pt: "Nova senha",
                en: "New password",
              })
            }}
          </span>
        </div>
        <form @submit.prevent="sendEmail()">
          <div class="px-5 py-3">
            <div class="flex flex-col my-4">
              <InputPassword
                id="password-input"
                v-model="form.password"
                :feedback="false"
                toggleMask
                placeholder="Senha"
                :class="v$.form.password.$error ? 'p-invalid' : ''"
              />
              <Errors :errors="v$.form.password.$errors" />
            </div>
            <div class="flex flex-col my-4">
              <InputPassword
                id="confirm-password-input"
                v-model="form.confirmPassword"
                :feedback="false"
                toggleMask
                placeholder="Confirmar senha"
                :class="v$.form.confirmPassword.$error ? 'p-invalid' : ''"
              />
              <Errors :errors="v$.form.confirmPassword.$errors" />
            </div>
          </div>
          <div
            class="bg-gray-50 p-4 flex justify-end items-center mt-3 border-t border-t-gray-300 rounded-b-lg"
          >
            <Button
              type="button"
              label="Retornar ao login"
              class="btn-simple"
              @click="go.redirectTo('sign-in')"
            />
            <Button
              type="submit"
              label="Enviar"
              class="btn-primary"
              :loading="loading"
            />
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { minLength, required, sameAs } from "@/locale/locale.config";
import { ForgotPassword } from "@/models/auth.model";
import { AuthRest } from "@/services/rest/auth.rest";
import { GoToRoute } from "@/utils/go-to.util";
import useVuelidate from "@vuelidate/core";
import { delay } from "rxjs";
import { defineComponent } from "vue";

export default defineComponent({
  name: "newPassword",
  computed: {
    rest(): AuthRest {
      return new AuthRest();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
  data() {
    return {
      form: new ForgotPassword(),
      loading: false as boolean,
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      form: {
        password: { required, min: minLength(3) },
        confirmPassword: {
          sameAs: sameAs(this.form.password),
        },
      },
    };
  },
  methods: {
    goTo(): void {
      this.$router.push({ name: "sign-in" });
    },

    sendEmail(): void {
      this.v$.form.$touch();
      if (!this.v$.form.$error) {
        this.loading = true;
        const token: any = this.$route.params.id;
        const data = {
          password: this.form.password,
        };
        this.rest
          .forgotPassword(token, data)
          .pipe(delay(500))
          .subscribe({
            next: () => {
              this.go.redirectToPage("sign-in");
              this.loading = false;
            },
            error: () => {
              this.loading = false;
            },
          });
      }
    },
  },
});
</script>
